<template>


  <head>

    <meta charset="utf-8"/>
    <title>Desk Birdy | Medical Certificates</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description"/>
    <meta content="Kelvin Njuguna" name="author"/>
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet"
          type="text/css"/>

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
    <!-- Bootstrap select styling -->
    <link rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>

  </head>

  <body @contextmenu.prevent data-sidebar="dark">


  <!-- Begin page -->
  <div id="layout-wrapper">


    <NavigationBar/>
    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="page-header-box">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <div class="page-icon">
                      <i class="mdi mdi-certificate-outline"></i>
                    </div>
                    <div class="ms-3">
                      <h4 class="page-title mb-1">Active Medical Certificates</h4>
                      <p class="page-breadcrumb mb-0">
                        <span>Dashboard</span>
                        <i class="mdi mdi-chevron-right mx-1"></i>
                        <span>Certificates & Licenses</span>
                        <i class="mdi mdi-chevron-right mx-1"></i>
                        <span>Medical Certificates</span>
                      </p>
                    </div>
                  </div>
                  <div class="header-stats-row d-flex">
                    <div class="header-stat-box">
                      <span class="stat-number">{{ numberFormat(totalBusiness) }}</span>
                      <span class="stat-text">TOTAL CERTIFICATES</span>
                    </div>
                    <div class="header-stat-box stat-success">
                      <span class="stat-number">KES {{ numberFormat(totalAmount) }}</span>
                      <span class="stat-text">TOTAL REVENUE</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarMedical/>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <!-- Card Header -->
                <div class="card-header bg-white border-bottom">
                  <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div>
                      <h5 class="card-title mb-1">
                        <i class="mdi mdi-clipboard-check-outline me-2 text-primary"></i>
                        Approved Medical Certificates
                      </h5>
                      <p class="text-muted mb-0 small">View and manage all active medical health certificates</p>
                    </div>
                    <div class="header-search-box">
                      <div class="position-relative">
                        <i class="mdi mdi-magnify search-icon"></i>
                        <input
                            v-model="search"
                            type="text"
                            class="form-control search-input"
                            placeholder="Search by name, ID, bill number..."
                        >
                        <button v-if="search" @click="search = ''" class="btn-clear">
                          <i class="mdi mdi-close"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card Body -->
                <div class="card-body p-0">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <p class="mt-3 text-muted">Loading records...</p>
                  </div>

                  <!-- Empty State -->
                  <div v-if="pendingInvoicing.length < 1 && loading === false" class="text-center py-5">
                    <img src="assets/images/no-results.png" class="mb-4" style="height: 120px;" alt="No results"/>
                    <h5>No Records Found</h5>
                    <p class="text-muted">We couldn't find any certificates matching your search criteria.</p>
                    <button v-if="search" @click="search = ''" class="btn btn-outline-primary btn-sm">
                      <i class="mdi mdi-refresh me-1"></i> Clear Search
                    </button>
                  </div>

                  <!-- Data Table -->
                  <div v-if="pendingInvoicing.length > 0 && !loading" class="table-responsive">
                    <table class="table table-hover table-striped mb-0">
                      <thead class="table-light">
                      <tr>
                        <th>CERTIFICATE HOLDER</th>
                        <th>INVOICE DETAILS</th>
                        <th>LOCATION</th>
                        <th>VALIDITY PERIOD</th>
                        <th>AMOUNT</th>
                        <th>STATUS</th>
                        <th class="text-end">ACTIONS</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in pendingInvoicing" :key="index">
                        <td>
                          <div class="d-flex align-items-center">
                            <div class="avatar-circle">
                              {{ getInitials(item.names) }}
                            </div>
                            <div class="ms-3">
                              <h6 class="mb-0 fw-semibold">{{ item.names }}</h6>
                              <small class="text-muted">
                                <i class="mdi mdi-card-account-details-outline me-1"></i>
                                ID: {{ item.idNo }}
                              </small>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="fw-medium text-primary">{{ item.billNo }}</span>
                            <br>
                            <small class="text-muted">
                              <i class="mdi mdi-calendar-outline me-1"></i>
                              {{ formatDate(item.dateCreated) }}
                            </small>
                          </div>
                        </td>
                        <td>
                          <div>
                              <span>
                                <i class="mdi mdi-map-marker-outline text-danger me-1"></i>
                                {{ item.subCountyName }}
                              </span>
                            <br>
                            <small class="text-muted">{{ item.wardName }}</small>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ formatDateShort(item.startDate) }} - {{ formatDateShort(item.endDate) }}</span>
                            <br>
                            <span class="badge badge-validity" :class="getValidityClass(item.endDate)">
                                <i class="mdi mdi-clock-outline me-1"></i>
                                {{ getDaysRemaining(item.endDate) }}
                              </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span class="fw-semibold">KES {{ numberFormat(item.billTotal) }}</span>
                            <br>
                            <span class="badge" :class="item.billBalance == 0 ? 'bg-success' : 'bg-warning'">
                                {{ item.billBalance == 0 ? 'Paid' : 'Balance: ' + numberFormat(item.billBalance) }}
                              </span>
                          </div>
                        </td>
                        <td>
                            <span class="badge badge-status" :class="getStatusClass(item.stageStatus)">
                              <i class="mdi me-1" :class="getStatusIcon(item.stageStatus)"></i>
                              {{ item.stageStatus }}
                            </span>
                        </td>
                        <td>
                          <div class="d-flex justify-content-end gap-2">
                            <button
                                @click="getDetails(item)"
                                class="btn btn-sm btn-light"
                                data-bs-toggle="modal"
                                data-bs-target=".details-modal"
                                title="View Details"
                            >
                              <i class="mdi mdi-eye-outline"></i>
                            </button>
                            <button
                                v-if="item.printable === 'true'"
                                @click="printPermit(item.idNo)"
                                class="btn btn-sm btn-outline-primary"
                                title="Print Certificate"
                            >
                              <i class="mdi mdi-certificate-outline"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Table Footer -->
                  <div v-if="!loading && pendingInvoicing.length > 0" class="card-footer bg-light border-top d-flex justify-content-between align-items-center">
                    <span class="text-muted">
                      Showing <strong>{{ pendingInvoicing.length }}</strong> certificates
                    </span>
                    <div>
                      <span class="me-3">
                        <i class="mdi mdi-file-document-multiple-outline me-1"></i>
                        {{ numberFormat(totalBusiness) }} Total
                      </span>
                      <span class="text-success fw-semibold">
                        <i class="mdi mdi-cash me-1"></i>
                        KES {{ numberFormat(totalAmount) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Details Modal -->
      <div class="modal fade details-modal" tabindex="-1" role="dialog" aria-labelledby="detailsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header modal-header-dark">
              <div class="d-flex align-items-center">
                <div class="modal-header-icon">
                  <i class="mdi mdi-account-details"></i>
                </div>
                <div class="ms-3">
                  <h5 class="modal-title mb-0">Certificate Details</h5>
                  <small class="text-muted">{{ selectedItem.names }}</small>
                </div>
              </div>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <!-- Processing Timeline -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-timeline-clock-outline me-2"></i>
                  Processing Timeline
                </h6>
                <div class="timeline-row">
                  <div class="timeline-step completed">
                    <div class="timeline-dot">
                      <i class="mdi mdi-check"></i>
                    </div>
                    <div class="timeline-label">Invoicing</div>
                    <div class="timeline-date">{{ formatDate(selectedItem.dateCreated) }}</div>
                  </div>
                  <div class="timeline-line"></div>
                  <div class="timeline-step completed">
                    <div class="timeline-dot">
                      <i class="mdi mdi-check"></i>
                    </div>
                    <div class="timeline-label">Payment</div>
                    <div class="timeline-date">Completed</div>
                  </div>
                  <div class="timeline-line"></div>
                  <div class="timeline-step" :class="selectedItem.stageStatus === 'Approved' ? 'completed' : ''">
                    <div class="timeline-dot">
                      <i class="mdi" :class="selectedItem.stageStatus === 'Approved' ? 'mdi-check' : 'mdi-clock-outline'"></i>
                    </div>
                    <div class="timeline-label">Approval</div>
                    <div class="timeline-date">{{ selectedItem.stageStatus }}</div>
                  </div>
                </div>
              </div>

              <!-- Personal Information -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-account-outline me-2"></i>
                  Personal Information
                </h6>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">FULL NAME</label>
                    <p class="mb-0 fw-medium">{{ selectedItem.names }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">ID NUMBER</label>
                    <p class="mb-0 fw-medium">{{ selectedItem.idNo }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">SUB COUNTY</label>
                    <p class="mb-0 fw-medium">{{ selectedItem.subCountyName }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">WARD</label>
                    <p class="mb-0 fw-medium">{{ selectedItem.wardName }}</p>
                  </div>
                </div>
              </div>

              <!-- Certificate Information -->
              <div class="section-block mb-4">
                <h6 class="section-title">
                  <i class="mdi mdi-certificate-outline me-2"></i>
                  Certificate Information
                </h6>
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">BILL NUMBER</label>
                    <p class="mb-0 fw-medium font-monospace">{{ selectedItem.billNo }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">ISSUE DATE</label>
                    <p class="mb-0 fw-medium">{{ formatDate(selectedItem.dateOfIssue) }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">VALID FROM</label>
                    <p class="mb-0 fw-medium">{{ formatDate(selectedItem.startDate) }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">VALID UNTIL</label>
                    <p class="mb-0 fw-medium">{{ formatDate(selectedItem.endDate) }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">ISSUING OFFICER</label>
                    <p class="mb-0 fw-medium">{{ selectedItem.issuingOfficer }}</p>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label class="form-label text-muted small mb-1">AMOUNT PAID</label>
                    <p class="mb-0 fw-semibold text-success">KES {{ numberFormat(selectedItem.billTotal) }}</p>
                  </div>
                </div>
              </div>

              <!-- Medical Findings -->
              <div class="section-block" v-if="selectedItem.description">
                <h6 class="section-title">
                  <i class="mdi mdi-clipboard-text-outline me-2"></i>
                  Medical Findings / Remarks
                </h6>
                <div class="findings-box">
                  {{ formatDescription(selectedItem.description) }}
                </div>
              </div>

              <!-- Approval Comments -->
              <div class="section-block mt-4" v-if="selectedItem.comments">
                <h6 class="section-title">
                  <i class="mdi mdi-comment-text-outline me-2"></i>
                  Approval Comments
                </h6>
                <div class="comments-box">
                  {{ selectedItem.comments }}
                </div>
              </div>
            </div>

            <div class="modal-footer bg-light">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                <i class="mdi mdi-close me-1"></i> Close
              </button>
              <button @click="printBill(selectedItem.billNo)" class="btn btn-outline-primary">
                Print Invoice
              </button>
              <button
                  v-if="selectedItem.printable === 'true'"
                  @click="printPermit(selectedItem.idNo)"
                  class="btn btn-primary"
              >
                <i class="mdi mdi-certificate-outline me-1"></i> Print Certificate
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6"></div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  <div class="rightbar-overlay"></div>

  </body>


</template>

<script>
/* eslint-disable */
import { defineComponent } from "vue";
import NavigationBar from "@/components/Navigation.vue";
import ToolBarMedical from "@/components/medical/ToolBarMedical.vue";
import { execute, biller, health } from "@/api";

export default {
  name: "active-medical-cert",
  components: { ToolBarMedical, NavigationBar },

  data() {
    return {
      loading: true,
      search: '',
      pendingInvoicing: [],
      selectedItem: {
        id: null,
        billNo: null,
        idNo: null,
        names: null,
        duration: null,
        billTotal: null,
        receiptAmount: null,
        billBalance: null,
        startDate: null,
        endDate: null,
        statusID: null,
        status: null,
        printable: null,
        issuingOfficer: null,
        designation: null,
        dateOfIssue: null,
        stageStatus: null,
        comments: null,
        incomeTypeId: null,
        feeID: null,
        subCountyName: null,
        wardName: null,
        dateCreated: null,
        subCountyID: null,
        wardID: null,
        description: null
      },
      totalBusiness: 0,
      totalAmount: 0
    }
  },

  mounted() {
    this.getPendingApprovalMedical();
    this.menuAccess();
  },

  watch: {
    search() {
      this.getPendingApprovalMedical();
    }
  },

  methods: {
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Active Medical Cert");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller).catch((e) => console.error(e));
    },

    getInitials(name) {
      if (!name) return '?';
      const parts = name.split(' ');
      return parts.length >= 2
          ? (parts[0][0] + parts[1][0]).toUpperCase()
          : name.substring(0, 2).toUpperCase();
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const date = new Date(dateString);
      return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
    },

    formatDateShort(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      const day = date.getDate();
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const year = date.getFullYear().toString().slice(-2);
      return `${day} ${months[date.getMonth()]} ${year}`;
    },

    getDaysRemaining(endDate) {
      if (!endDate) return '-';
      const end = new Date(endDate);
      const now = new Date();
      const diff = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
      if (diff < 0) return 'Expired';
      if (diff === 0) return 'Expires today';
      if (diff === 1) return '1 day left';
      return `${diff} days left`;
    },

    getValidityClass(endDate) {
      if (!endDate) return 'bg-secondary';
      const end = new Date(endDate);
      const now = new Date();
      const diff = Math.ceil((end - now) / (1000 * 60 * 60 * 24));
      if (diff < 0) return 'bg-danger';
      if (diff <= 30) return 'bg-warning';
      return 'bg-success';
    },

    getStatusClass(status) {
      switch (status?.toLowerCase()) {
        case 'approved': return 'status-approved';
        case 'pending': return 'status-pending';
        case 'declined': return 'status-declined';
        default: return 'status-default';
      }
    },

    getStatusIcon(status) {
      switch (status?.toLowerCase()) {
        case 'approved': return 'mdi-check-circle';
        case 'pending': return 'mdi-clock-outline';
        case 'declined': return 'mdi-close-circle';
        default: return 'mdi-help-circle';
      }
    },

    formatDescription(description) {
      if (!description) return '';
      return description.replace(/[\[\]"]/g, '').replace(/,/g, ', ');
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num || 0);
    },

    printPermit(idNo) {
      const data = new FormData();
      data.append("function", "printPermitMedical");
      data.append("idNo", idNo);
      execute(data, health)
          .then((res) => {
            if (res.data.success) {
              localStorage['params'] = JSON.stringify({ idNo: idNo });
              const routeData = this.$router.resolve({ name: 'medical-certificate' });
              window.open(routeData.href, '_blank');
            } else {
              alert(res.data.message);
            }
          })
          .catch((e) => alert(e.message));
    },

    getPendingApprovalMedical() {
      this.loading = true;
      this.pendingInvoicing = [];

      const data = new FormData();
      data.append("function", "getPendingApprovalMedical");
      data.append("keyword", this.search);
      data.append("statusID", "5");

      execute(data, health)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.pendingInvoicing = res.data.data.pendingInvoicing || [];
              this.totalBusiness = this.pendingInvoicing.length;
              this.totalAmount = this.pendingInvoicing.reduce((acc, cur) => {
                const amount = Number(cur.billTotal);
                return !isNaN(amount) ? acc + amount : acc;
              }, 0);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error(e);
          });
    },

    getDetails(item) {
      this.selectedItem = { ...item };
    },

    printBill(billNo) {
      localStorage['params'] = JSON.stringify({ billNo: billNo });
      const routeData = this.$router.resolve({ name: 'bill' });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>

<style scoped>
/* Page Header */
.page-header-box {
  background: #fff;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.page-icon {
  width: 50px;
  height: 50px;
  background: #2a3f54;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: #2a3f54;
}

.page-breadcrumb {
  font-size: 13px;
  color: #6c757d;
}

.page-breadcrumb span:last-child {
  color: #2a3f54;
  font-weight: 500;
}

.header-stats-row {
  gap: 12px;
}

.header-stat-box {
  background: #2a3f54;
  border-radius: 8px;
  padding: 12px 20px;
  text-align: center;
  min-width: 140px;
}

.header-stat-box.stat-success {
  background: #28a745;
}

.stat-number {
  display: block;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}

.stat-text {
  display: block;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  letter-spacing: 0.5px;
  margin-top: 2px;
}

/* Search Box */
.header-search-box {
  min-width: 300px;
}

.header-search-box .search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #adb5bd;
  font-size: 18px;
}

.header-search-box .search-input {
  padding-left: 40px;
  padding-right: 36px;
  border-radius: 6px;
  border: 1px solid #e9ecef;
  height: 40px;
}

.header-search-box .search-input:focus {
  border-color: #2a3f54;
  box-shadow: 0 0 0 2px rgba(42, 63, 84, 0.1);
}

.header-search-box .btn-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #adb5bd;
  cursor: pointer;
  padding: 4px;
}

.header-search-box .btn-clear:hover {
  color: #495057;
}

/* Avatar Circle */
.avatar-circle {
  width: 40px;
  height: 40px;
  background: #2a3f54;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
}

/* Status Badges */
.badge-status {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-approved {
  background: #d4edda;
  color: #155724;
}

.status-pending {
  background: #fff3cd;
  color: #856404;
}

.status-declined {
  background: #f8d7da;
  color: #721c24;
}

.status-default {
  background: #e9ecef;
  color: #495057;
}

/* Validity Badge */
.badge-validity {
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
}

/* Table Styling */
.table thead th {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #495057;
  border-bottom: 2px solid #e9ecef;
  padding: 12px 16px;
  white-space: nowrap;
}

.table tbody td {
  padding: 14px 16px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f3f5;
}

.table tbody tr:hover {
  background: #f8f9fa;
}

/* Modal Styling */
.modal-header-dark {
  background: #fff;
  color: #2a3f54;
  border-bottom: 1px solid #e9ecef;
  padding: 16px 20px;
}

.modal-header-icon {
  width: 44px;
  height: 44px;
  background: #2a3f54;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
}

.modal-header-dark .modal-title {
  color: #2a3f54;
}

.modal-header-dark small {
  color: #6c757d;
}

/* Section Blocks */
.section-block {
  padding-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
}

.section-block:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #2a3f54;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
}

.section-title i {
  color: #2a3f54;
}

/* Timeline */
.timeline-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 20px;
}

.timeline-step {
  text-align: center;
  flex: 1;
  position: relative;
}

.timeline-dot {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
  color: #adb5bd;
  font-size: 16px;
}

.timeline-step.completed .timeline-dot {
  background: #28a745;
  color: #fff;
}

.timeline-label {
  font-weight: 600;
  font-size: 13px;
  color: #495057;
}

.timeline-date {
  font-size: 12px;
  color: #adb5bd;
}

.timeline-line {
  flex: 0 0 60px;
  height: 2px;
  background: #e9ecef;
  margin-top: 18px;
}

/* Findings Box */
.findings-box {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px 16px;
  border-left: 3px solid #2a3f54;
  font-size: 14px;
  color: #495057;
}

.comments-box {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px 16px;
  border-left: 3px solid #28a745;
  font-size: 14px;
  color: #495057;
}

/* Card Footer */
.card-footer {
  padding: 12px 16px;
  font-size: 13px;
}

/* Responsive */
@media (max-width: 992px) {
  .header-search-box {
    min-width: 100%;
    margin-top: 16px;
  }

  .header-stats-row {
    width: 100%;
    justify-content: flex-end;
    margin-top: 16px;
  }
}

@media (max-width: 768px) {
  .page-header-box {
    padding: 16px;
  }

  .page-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .page-title {
    font-size: 16px;
  }

  .header-stat-box {
    padding: 10px 16px;
    min-width: 120px;
  }

  .stat-number {
    font-size: 16px;
  }

  .timeline-row {
    padding: 0;
  }

  .timeline-line {
    flex: 0 0 30px;
  }
}
</style>